import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Музеи и выставочные залы Museums and Show-rooms";

    const itemsData = [
        {
            id: 1,
            location: 'Брест',
            name: 'Брестский областной краеведческий музей',
            adress: '224646 г. Брест, ул. К. Маркса, 60',
            timeWork: 'Часы работы: 10 - 18. Выходные дни: воскресенье, понедельник',
            phones: [
                '(+375) 162 23-91-16',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/muz550.jpg'),
                    alt: 'Брестский областной краеведческий музей',
                }
            ],
            desc: [
                'Основан в 1950 году. Открыт 22 июня 1957 года.',
                'Фонды музея насчитывают 143677 экспонатов основного фонда, в который входят следующие коллекции: живописи (2005 ед.), графики (24629 ед.), скульптуры (32 ед.), декоративно-прикладного искусства (1490 ед.), нумизматики (17841 ед., в том числе клады 3454ед.), археологии (49242 ед.), предметов этнографии и быта (1121 ед.), стекла и фарфора (361 ед.), оружия ( 431 ед.), одежды (554 ед.), мебели (52 ед.), музыкальных инструментов (43 ед.), старопечатных изданий (51 ед.), рукописных книг (9 ед.), драгоценных металлов и камней (1347 ед.), фотоматериалов (84 ед.). Многие из коллекций уникальные.',
                'Музей занимается сбором, научной обработкой и сохранением движимых историко-культурных ценностей, создает на их основе художественно-образные экспозиции и выставки, оказывает методическую помощь городским и районным краеведческим музеям.',
                'В отделе природы экспонаты растительного и животного мира области, озвученные диорамы «Беловежская пуща», «Полесье». В отделе истории досоветского периода археологической и нумизматической коллекции, оружие и доспехи воинов 13 - 18 в., рукописные и печатные книги (требник 1646 из Брестской церкви, рукописный «Апостол» 17 в.), макет Бреста 18 в., герб и печать города, обмундирование и оружие периода Отечественной войны 1812, этнографическая коллекция, в том числе музыкальные инструменты 18 в. (цитра, музыкальная шкатулка), орудия труда и предметы быта крестьян 19 в., памятная бронзовая доска и шкатулка с монетами, заложенные при основании Брестской крепости, карты и планы крепости. Среди экспонатов материалы о Брестской организации РСДРП, выступлениях трудящихся во время Революции 1905 - 07. В отделе истории советского периода экспонируются документы, боевые реликвии, награды, фотоснимки известных земляков - участников Октябрьской революции и Гражданской войны, материалы о первых на Брестчине ревкомах. В экспозициях отражена борьба трудящихся Западной Белоруссии во главе с КПЗБ за социальное и национальное освобождение, за воссоединение с БССР, представлены материалы о деятелях КПЗБ В. З. Хоружей, С. С. Панковой, В. З. Царюке, З. Ф. Поплавском, о вооруженном выступлении крестьян 1933 в Кобринском повете, Берёза-Картузском концентрационном лагере, об походе Красной Армии в сентябре 1939, об обороне Брестской крепости в начале Великой Отечественной войны, о партизанском движении на территории области и его руководителях (С. И. Сикорском, А. Е. Клещёве, В. З. Корже, В. Е. Чернышёве, И. П. Урбановиче), об освобождении края Красной Армией, в том числе о Барановичско-Слонимской и Люблинско-Брестской операциях, Героях Советского Союза, отличившихся при освобождении области от немецко-фашистских оккупантов, и о земляках И. П. Мазуруке, А. С. Благовещенском, Г. Н. Холостякове, дважды Героях Советского Союза С. И. Грицевце, П. И Климуке, дважды Герое Социалистич. Труда В. А. Ралько.',
                'Филиалы: Археологический музей «Берестье», Музей партизанской славы (в урочище Хованщина, около д. Корочин Ивацевичского района). Отделы: Каменецкая башня.',
            ],
        },
        {
            id: 2,
            location: 'Брест',
            name: 'Археологический музей «Берестье»',
            adress: '224018 г. Брест, Крепость, Госпитальный остров',
            timeWork: 'Часы работы: 10 - 18. Выходные дни: понедельник, вторник',
            url: 'http://berestie.iatp.by',
            phones: [
                '(+375) 162 20-55-98',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/ber550.jpg'),
                    alt: '',
                }
            ],
            desc: [
                'Открыт 2.03.1982 г.',
                'Археологический музей «Берестье» является единственным в Европе музеем средневекового восточнославянского города. Он находится на территории Волынского укрепления Брестской крепости, на месте, где зарождился город. Его экспозиция посвящена возникновению, политическому, экономическому и культурному развитию Берестья (Бреста) в ХI-ХIII вв.',
                'Основой для создания музея и явились вскрытые хорошо сохранившиеся постройки XIII в. Археологический раскоп - главный экспонат музея занимает площадь 1000 м. На глубине 4 м находится часть ремесленного квартала ХIII в. - 30 жилых и хозяйственных построек и две улицы. Две жилые постройки сохранились на 12 венцов (бревен), что является большой редкостью в славянской археологии. Постройки и уличные мостовые были законсервированы синтетическими веществами. Состав и способ консервации были разработаны сотрудниками технологического университета под руководством Вихрова В.Е., доктора сельскохозяйственных наук.',
                'Экспозиция расположена в 14 залах музейного павильона. Оригинальный музейный павильон площадью 2400 м2 построен из бетона, стекла и алюминия.',
                'филиал Брестского областного краеведческого музея',
            ],
        },
        {
            id: 3,
            location: 'Брест',
            name: 'Музей «Спасенные художественные ценности»',
            adress: '224000 г. Брест, ул. Ленина, 39',
            timeWork: 'Часы работы: 10 - 18. Выходные дни: понедельник, вторник.',
            phones: [
                '(+375) 162 20-41-95',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/sc550.jpg'),
                    alt: 'Музей «Спасенные художественные ценности»',
                }
            ],
            desc: [
                'филиал Брестского областного краеведческого музея',
            ],
        },
        {
            id: 4,
            location: 'Брест',
            name: 'Музей истории города Бреста',
            adress: '224003 г. Брест, ул. Леваневского, 3',
            timeWork: 'Режим работы: 10.00 – 18.00. Вход посетителей до 17.15. Выходной понедельник.',
            email: 'bresthistory@gmail.com',
            phones: [
                '(+375) 162 21-36-83 (научные сотрудники)',
                '(+375) 162 21-36-84 (администрация)',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/ist_gor.jpg'),
                    alt: 'Музей истории города Бреста',
                }
            ],
            desc: [
                'филиал Брестского областного краеведческого музея',
            ],
        },
        {
            id: 5,
            location: 'Брест',
            name: 'Художественный музей',
            adress: '224018 г. Брест, Крепость, Южные казармы',
            timeWork: 'Часы работы: 10 - 18. Выходные дни: понедельник, вторник.',
            phones: [
                '(+375) 162 20-51-36',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/hudmuz.jpg'),
                    alt: 'Художественный музей',
                }
            ],
            desc: [
                '17 мая 2002 года, в Южной казарме Брестской крепости открылся художественный музей.',
                'Посетители музея могут познакомиться с творчеством художников, скульпторов, мастеров декоративно - прикладного искусства.',
                'Большим интересом у посетителей пользуется экспозиция «Тайны старого города», где представлены живописные работы брестской художницы Анастасии Фетисовой и макет старого города, выполненный под ее руководством учащимися Брестского политехнического техникума.',
                'филиал Брестского областного краеведческого музея',
            ],
        },
        {
            id: 6,
            location: 'Брест',
            name: 'Государственное учреждение «Мемориальный комплекс «Брестская крепость-герой»',
            adress: '224018 г. Брест, Крепость',
            url: 'http://nacbibl.org.by',
            timeWork: 'Музей обороны Брестской крепости работает: с 1 марта до 31 октября с 930 до 1800 часов; с 1 ноября до 1 марта с 930 до 1700 часов; выходной день - понедельник; последний вторник каждого месяца - санитарный день; в период школьных каникул музей работает без выходных с 930 до 1800 часов. В праздничные дни режим работы музея определяет администрация.',
            phones: [
                '(+375) 162 20-03-65 (телефон для справок)',
                '(+375) 162 20-43-42 (заместитель директора по научной работе)',
                '(+375) 162 20-41-09 (директор)',
                '(+375) 162 20-42-11 (главный хранитель фондов)',
                '(+375) 162 20-00-12 (факс)',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/krep.jpg'),
                    alt: 'Мемориальный комплекс «Брестская крепость-герой»',
                }
            ],
            desc: [
                'Мемориальный комплекс «Брестская крепость-герой» расположен в западной части Бреста и включает в себя два из четырех (Цитадель и часть Кобринского) оборонительных укреплений памятника оборонной архитектуры XIX в. - Брестской крепости.',
                'Мемориал открыт для посещения с 800 до 2400 часов.',
                'Музей обороны Брестской крепости был открыт 8 ноября 1956 г. в сохранившейся части оборонительной казармы Цитадели.',
            ],
        },
        {
            id: 7,
            location: 'Брест',
            name: 'Выставочный зал областного общественно-культурного центра',
            adress: '224005 г. Брест, ул. Коммунистическая, 1',
            phones: [
                '(+375) 162 23-36-86',
            ],
        },
        {
            id: 8,
            location: 'Брест',
            name: 'Выставочный зал областного общественно-культурного центра',
            adress: '224030, г. Брест, ул.Советская, 54',
            phones: [
                '(+375) 162 21-27-76',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/ws.jpg'),
                    alt: 'Выставочный зал областного общественно-культурного центра',
                }
            ],
        },
        {
            id: 9,
            location: 'Брест',
            name: 'Музей железнодорожной техники г. Брест',
            adress: '224000, г. Брест, проспект Машерова, 2',
            timeWork: 'Музей работает: С мая по октябрь с 10.00 до 18.00. С ноября по апрель с 11.00 до 17.00. Выходной - понедельник',
            phones: [
                '(+375) 162 27-47-64',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/mzd550.jpg'),
                    alt: 'Музей железнодорожной техники г. Брест',
                }
            ],
            desc: [
                'Основан в 2002 году.',
                'Брестский музей железнодорожной техники расположен недалеко от мемориального комплекса «Брестская крепость—герой».',
                'Стараниями заслуженного железнодорожника, первого директора брестского музея Аркадия Приветеня здесь собрано более полусотни уникальных экспонатов локомотивов, вагонов и прочих железнодорожных агрегатов выпуска начала и середины прошлого века.',
            ],
        },
        {
            id: 10,
            location: 'Барановичи',
            name: 'Барановичский краеведческий музей',
            adress: '225320 г. Барановичи, ул. Советская, 72',
            phones: [
                '(+375) 163 42-15-24',
            ],
            desc: [
                'Музей в Барановичах был создан по инициативе преподавателя одной из городских гимназий проф. Л. Турского в октябре 1929 года.',
                'После войны фактически создан вновь в 1952-1953 гг. Коллекция музея составляет 54841 музейный предмет.',
            ],
        },
        {
            id: 11,
            location: 'Барановичи',
            name: 'Выставочный зал Барановичского краеведческого музея',
            adress: '225320 г. Барановичи, ул. Советская, 88',
            phones: [
                '(+375) 163 42-27-86',
            ],
        },
        {
            id: 12,
            location: 'Барановичи',
            name: 'Музей истории Барановичского отделения Белорусской железной дороги',
            adress: '225320 г. Барановичи, ул. Фроленкова',
            phones: [
                '(+375) 163 49-39-67',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/bar.jpg'),
                    alt: 'Музей истории Барановичского отделения Белорусской железной дороги',
                }
            ],
            desc: [
                '30 июля 1999 года в г.Барановичах открылся первый на Белорусской железной дороге музей железнодорожной техники.',
                'Экспонаты музея разнообразны и ценны. Старейшим в этой замечательной коллекции является паровоз серии Эм Е733-87, построенный на Луганском паровозостроительном заводе в 1934 году.',
                'Здесь представлены локомотивы отечественной и зарубежной постройки, которые в разные годы эксплуатировались на сети дорог Союза ССР. В экспозиции музея имеются образцы пассажирских вагонов довоенной постройки, сохраненные в своем первозданном виде. После соответствующего переоборудования они представляют собой залы, в которых экспонируются приборы, механизмы, инструменты, использовавшиеся железнодорожниками в прошлом. В одном из таких вагонов установлен макет Барановичского железнодорожного узла в действии.',
            ],
        },
        {
            id: 12,
            location: 'Барановичский район',
            name: 'Музей-усадьба А. Мицкевича',
            adress: '225320 Брестская область, Барановичский район, д. Заосье',
            phones: [
                '(+375) 163 43-25-10',
            ],
        },
        {
            id: 13,
            location: 'Береза',
            name: 'Березовский историко-краеведческий музей',
            adress: '225210 г. Береза, ул. Ленина, 67',
            phones: [
                '(+375) 1643 2-27-71',
            ],
            desc: [
                'Открыт в 1965 г. Коллекция музея составляет 26054 музейных предмета.',
                'В историко-краеведческом музее г. Березы собран богатый материал о Березе и районе.',
            ],
        },
        {
            id: 14,
            location: 'Ганцевичи',
            name: 'Ганцевичский районный краеведческий музей',
            adress: '225440, г. Ганцевичи, ул. Заслонова, 1',
            phones: [
                '(+375) 1646 2-14-51',
            ],
        },
        {
            id: 15,
            location: 'Дрогичин',
            name: 'Народный музей партизанской славы',
            adress: '225848, г. Дрогичин, ул. Ленина, 163',
            phones: [
                '(+375) 1644 2-14-22',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/drog2.jpg'),
                    alt: 'Народный музей партизанской славы',
                }
            ],
            desc: [
                'В 1994 году был открыт Дрогичинский народный музей партизанской славы им. Д.К.Удовикова.',
            ],
        },
        {
            id: 16,
            location: 'Дрогичинский район',
            name: 'Музей народного творчества «Бездежскi фартушок»',
            adress: '225848 Брестская область, Дрогичинский район, д. Бездеж, ул. Пионерская, 9',
            phones: [
                '(+375) 1644 7-49-99',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/bzd550.jpg'),
                    alt: 'Музей народного творчества «Бездежскi фартушок»',
                }
            ],
            desc: [
                'Бездежский музей народного творчества «Бездзежскі фартушок» был открыт 17.01.1999г. в д. Бездеж. Экспозиция этого музея размещена в 6 залах. Собран богатый материал ткачества и вышивки мастериц Бездежа и прилегающих деревень. Главное место в экспозиции занимают фартушки (около 150 экспонатов)',
            ],
        },
        {
            id: 17,
            location: 'Ивановский район',
            name: 'Мотольский музей народного творчества',
            adress: '225822 Брестская область, Ивановский район, д. Мотоль',
            phones: [
                '(+375) 1652 5-87-53',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/mot550.jpg'),
                    alt: 'Мотольский музей народного творчества',
                }
            ],
            desc: [
                'Мотольский музей народного творчества открыт в августе 1995 года.Фонд музея насчитывает 27506 экспонатов, оформлено 8 экспозиционных залов: выставочный, истории, ремёсел, ткачества, одежды,обрядов,народных традиций.',
                'Сотрудниками музея собрана большая коллекция бытовых, обрядовых,праздничных,календарных песен,разработано более двадцати учебных экскурсий для учащихся средних школ.',
                'Ежегодно музей посещают 19,7 тыс.человек.',
            ],
        },
        {
            id: 18,
            location: 'Ивановский район',
            name: 'Музей народной медицины',
            adress: '225822 Брестская область, Ивановский район, д. Стрельно',
            phones: [
                '(+375) 1652 3-92-44',
            ],
        },
        {
            id: 19,
            location: 'Ивацевичский район',
            name: 'Мемориальный музей «Хованщина»',
            adress: '225250 Брестская область, Ивацевичский район, д. Корочинь',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/how.jpg'),
                    alt: 'Мемориальный музей «Хованщина»',
                }
            ],
            desc: [
                'МУЗЕЙ ПАРТИЗАНСКОЙ СЛАВЫ. Создан в 1971 в 3 км от д. Корочин Ивацевичского района, в урочище Хованщина, где в 1943 - 44 базировались Брестские подпольные обкомы КП(б)Б и ЛКСМБ, штаб Брестского партизанского соединения, редакция и типография подпольной газеты «Заря» - органа Брестского подпольного обкома КП(б)Б. Филиал Брестского областного краеведческого музея. Расположен на территории мемориального комплекса, воссоздающего обстановку партизанского лагеря: 4 деревянных домика, 2 землянки, колодец, «лесная школа». В одном домике экспонаты рассказывают о деятельности подпольного обкома КП(б)Б и штаба партизанского соединения, в другом - о деятельности подп, обкома ЛКСМБ и о борьбе комсомольцев и молодёжи Брестчины против немецко-фашистских захватчиков, в третьем - о работе редакции подпольной газеты «Заря», в четвёртом - о работе партизанского госпиталя. На территории комплекса установлены стенды с фотографиями, схемами, текстом «Присяги белорусского партизана» и др.; при входе - большой валун с памятной надписью. Ежегодно в последнее воскресенье мая здесь проводится традиционная встреча бывших партизан Брестского партизанского соединения.',
            ],
        },
        {
            id: 20,
            location: 'Ивацевичи',
            name: 'Ивацевичский историко-краеведческий музей',
            adress: '225250, г. Ивацевичи, ул. Дзержинского, 18',
            phones: [
                '(+375) 1645 2-31-66',
            ],
            desc: [
                'Открыт в 1993 г. Коллекция музея составляет 1425 музейных предметов.',
            ],
        },
        {
            id: 21,
            location: 'Каменецкий район',
            name: 'Государственный Национальный парк «Беловежская пуща» Музей природы',
            adress: '225050 Брестская область, Каменецкий район, д. Каменюки',
            phones: [
                '(+375) 1631 5-62-68',
                '(+375) 1631 5-63-70',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/zu1550.jpg'),
                    alt: 'Государственный Национальный парк «Беловежская пуща» Музей природы',
                }
            ],
            desc: [
                'МУЗЕЙ ПРИРОДЫ БЕЛОВЕЖСКОЙ ПУЩИ. Основан в 1945 на базе коллекций научного отдела заповедника Беловежская пуща, открыт в 1950 в д. Каменюки Каменецкого района. Площадь музея 865 м2, площадь экспозиции 775 м2 (1986).',
                'Экспозиция музея развёрнута в залах по тематическим разделам: история Беловежской пущи, птицы, водные животные, земноводные и пресмыкающиеся, вредители лесов, почвы, научная работа. В залах музея демонстрируются чучела типичных представителей животного мира пущи - зубра, оленя, дикого кабана, лося, лисицы, бобра, ондатры, выдры, енотовидной собаки, барсука, рыси, волка, горностая, куницы, ласки, чёрного хорька и др. обитателей леса, водоёмов, болот, полей и лугов; коллекция трутовых грибов, декоративная карта пущи, фотоснимки, материалы по истории Беловежской пущи и др. В комплекс показательного сектора входят вольеры с основными представителями беловежской фауны - зубрами, оленями, лосями, дикими кабанами, косулями. Ежегодно музей посещает около 150 тысяч человек.',
            ],
        },
        {
            id: 22,
            location: 'Каменец',
            name: 'Музей «Каменецкая башня»',
            adress: '225050 Брестская область, г. Каменец, ул. Ленина, 39',
            timeWork: 'Часы работы: 10 - 18. Выходные дни: понедельник, вторник.',
            phones: [
                '(+375) 1631 2-25-64',
                '(+375) 1631 2-25-64',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/kb550.jpg'),
                    alt: 'Музей «Каменецкая башня»',
                }
            ],
            desc: [
                '(филиал Брестского областного краеведческого музея)',
            ],
        },
        {
            id: 23,
            location: 'Кобрин',
            name: 'Учреждение культуры «Кобринский военно-исторический музей им. А. В. Суворова»',
            adress: '225306 г. Кобрин, ул. Суворова, 14',
            timeWork: 'Режим работы: 10.00-17.00 без обеда. Выходной - понедельник, вторник',
            phones: [
                '(+375) 1642 2-37-94 (Директор)',
                '(+375) 1642 2-55-31 (научные сотрудники)',
                '(+375) 1642 2-59-11 (касса музея)',
                '(+375) 1642 2-56-94 (касса музея)',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/suwr550.jpg'),
                    alt: 'Кобринский военно-исторический музей',
                }
            ],
            desc: [
                'Создан в 1946 году. Открыт для посетителей в 1948 г. Коллекция музея составляет 40855 музейных предметов.',
                'Музей включает в себя две экспозиции в двух разных зданиях. Первая экспозиция находится в мемориальном доме, который принадлежал великому русскому полководцу А. В. Суворову и повествует о жизни и деятельности Суворова. Здание является памятником архитектуры XVIII века. Вторая экспозиция расположена в кирпичном здании и повествует об истории Кобринщины с древнейших времен до наших дней. В экспозиции второго здания и в выставочном зале музея регулярно проводятся временные выставки из фондов Кобринского музея и других организаций. Кроме того действует постоянная выставка-продажа картин кобринских художников.',
            ],
        },
        {
            id: 24,
            location: 'Лунинец',
            name: 'Лунинецкий краеведческий музей',
            adress: '225650, г. Лунинец, ул. Советская, 16',
            phones: [
                '(+375) 1647 2-19-97',
            ],
            desc: [
                'Лунинецкий районный краеведческий музей открыт в 1978 году, экспозиция открыта в 1986 году. Коллекция музея составляет 9385 музейных предметов. С 2000 года функционирует выставочный зал. Музей ведет научно-исследовательскую работу, проводит выставки, лекции, презентации и творческие встречи, активно работают с местными краеведами. Сотрудники музея принимают участие в международных и республиканских конференциях, выступают с докладами по сохранению историко-культурного наследия.',
            ],
        },
        {
            id: 25,
            location: 'Пинск',
            name: 'Музей Белорусского Полесья',
            adress: '225710 г. Пинск, пл. Ленина, 22',
            phones: [
                '(+375) 165 35-49-86',
            ],
            desc: [
                'Открыт 1 июля 1926 года.',
                'В дни своего 70-летнего юбилея Музей Белорусского Полесья переехал в новое помещение — в здание бывшего иезуитского коллегиума.',
            ],
        },
        {
            id: 26,
            location: 'Пинский район',
            name: 'Народный литературный музей А.Блока',
            adress: '225712, Брестская обл., Пинский р-н, д. Лапатино, Дом культуры',
            phones: [
                '(+375) 165 39-49-75',
            ],
            desc: [
                'Открыт в В 1982 году. Более 4.000 экспонатов. Посетители знакомятся с такими разделами: «Родословная и детство Блока», «Юность, рождение поэта», «К серьезным раздумьям» - о дореволюционном творчестве Блока; «С думой о Родине», «Среди друзей в театре».',
                'Центральное место во втором зале занимает стенд о пребывании Блока на Белорусском Полесье. Здесь одних фотофафий около 50. На снимках запечатлены все памятные места, где бывал Блок. Удалось разыскать карты военных действии в годы первой мировой войны в здешних местах.',
                'Представлен триптих пинского художника Ивана Грицюты «Блок в Колбах». Здесь же и работа белорусского скульптора Руслана Дарьина - бюст поэта.',
            ],
        },
        {
            id: 27,
            location: 'Пружаны',
            name: 'Пружанский музей-усадьба «Пружанскі палацык»',
            adress: '225140 г. Пружаны, ул. Советская, 50',
            url: 'http://palacyk.by.ru/',
            email: 'palacyk@tut.by',
            phones: [
                '(+375) 1632 7-18-96',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/pru550.jpg'),
                    alt: 'Пружанский музей-усадьба «Пружанскі палацык»',
                }
            ],
            desc: [
                'Открыт в 1999 г. Коллекция музея составляет 1339 музейных предметов.',
            ],
        },
        {
            id: 28,
            location: 'Столин',
            name: 'Столинский краеведческий музей',
            adress: '225010 г. Столин, парк «Маньковичи»',
            email: 'myzej-st@mail.ru',
            phones: [
                '(+375) 1655 2-43-67',
                '(+375) 1655 2-23-96',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Museums/muz1.jpg'),
                    alt: 'Столинский краеведческий музей',
                },
                {
                    src: require('./../img/ReferenceInformation/Museums/muz11.jpg'),
                    alt: 'Столинский краеведческий музей',
                },
                {
                    src: require('./../img/ReferenceInformation/Museums/ikon.jpg'),
                    alt: 'Столинский краеведческий музей',
                }
            ],
            desc: [
                'Открыт в 1955 г. Коллекция музея составляет 18084 музейных предмета.',
            ],
        },
        {
            id: 29,
            location: 'Столинский район',
            name: 'Народный этнографический музей',
            adress: '225510, Брестская область, Столинский р-н, д. Теребличи',
            phones: [
                '(+375) 1655 9-73-51',
            ],
        },
    ];

    let get_all_list = (data) => {
        return (
            <ul>
                {data?.map((h) => {
                    const link = "/reference-information-museums/" + h.id;
                    return (<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress != undefined && <p>{data.adress}</p>}
                {data.phones != undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url != undefined && <a href={data.url}>{data.url}</a>}
                {data.email != undefined && <p>Email: <span>{data.email}</span></p>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data.timeWork != undefined && <p>{data.timeWork}</p>}
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}